import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/clients/ff5a48c1f030f673fbc44b0fd81e7291/web/dev.intento.ch/node_modules/next-intl/dist/esm/production/shared/NextIntlClientProvider.js");
;
import(/* webpackMode: "eager" */ "/home/clients/ff5a48c1f030f673fbc44b0fd81e7291/web/dev.intento.ch/node_modules/swiper/swiper.css");
;
import(/* webpackMode: "eager" */ "/home/clients/ff5a48c1f030f673fbc44b0fd81e7291/web/dev.intento.ch/node_modules/swiper/modules/navigation.css");
;
import(/* webpackMode: "eager" */ "/home/clients/ff5a48c1f030f673fbc44b0fd81e7291/web/dev.intento.ch/node_modules/swiper/modules/pagination.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/clients/ff5a48c1f030f673fbc44b0fd81e7291/web/dev.intento.ch/src/components/aboutUs/AboutUsPage.tsx");
